// extracted by mini-css-extract-plugin
module.exports = {"MapaLeaflet":"VisualitzacioMapa_MapaLeaflet__2NGSo"};